<template>
  <Modal id="account-moderation" modifier="auth">
    <template #default="{ close }">
      <div @click="close" class="modal-close">
        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.7854 5.78552L6.1788 16.3921" stroke="#D0D0D0" stroke-width="2"/>
          <path d="M16.7854 16.2855L6.1788 5.67892" stroke="#D0D0D0" stroke-width="2"/>
        </svg>
      </div>
      <h1>{{ $t('ModalAccountModeration.title') }}</h1>
      <div class="about">{{ $t('ModalAccountModeration.about') }}</div>
      <button class="primary large" type="button" @click="close">{{ $t('ModalAccountModeration.ok') }}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'

export default {
  name: 'ModalAccountModeration',
  components: { Modal },
}
</script>

<style lang="scss">
.modal-close {
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
}
</style>
